import { Card, Flex, Heading, TextField, Box } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { usePlansManager } from '../plans-manager.provider';

const PlansMangerFiltersView = () => {
   const plansManager = usePlansManager();
   return (
      <Card m="3" className="slider-filters">
         <Flex direction="column" gap="2">
            <Heading as="h4" weight="medium" color="gray">
               Filters
            </Heading>
            <Box minWidth="300px">
               <TextField.Root
                  placeholder="Search Plans by typing Plan Name"
                  size="3"
                  color="blue"
                  autoComplete="off"
                  onChange={(e) => plansManager.onSearchChange(e.target.value)}
               />
            </Box>
         </Flex>
      </Card>
   );
};

export const PlansMangerFilters = observer(PlansMangerFiltersView);
